module.exports = __webpack_public_path__ + "img/61200.88261e9f.jpg";